import { App_Url } from "@/whiteLable";
const CurrencySymbol = ({ currency, value }) => {
  // console.log("CurrencySymbol::", { currency, value });
  const isNumeric =
    (typeof value === "number" && !isNaN(value)) ||
    (typeof value === "string" && /^[+-]?\d+(\.\d+)?$/.test(value.trim()));
  if (!currency || !isNumeric) return null;

  const rawCurrencyCode = String(currency).trim().toUpperCase();
  // const normalizedCurrency = getDisplayCurrencyCode(currency);
  // const symbol = getCurrencySymbol(currency);

  if (rawCurrencyCode === "AED") {
    return <img src={App_Url.partners.symbols.Aed} alt="AED" className="h-3 w-auto inline-block" />;
  }

  return <span className="">{rawCurrencyCode}</span>;
};

export default CurrencySymbol;
